// extracted by mini-css-extract-plugin
var _1 = "loandetails_arrow__vtssr";
var _2 = "loandetails_arrowwrapper__ceijd";
var _3 = "#4c4c4c";
var _4 = "loandetails_button__qs0g+";
var _5 = "640px";
var _6 = "790px";
var _7 = "#057676";
var _8 = "loandetails_desktoptext__7mjj1";
var _9 = "loandetails_detailstext__7dfso";
var _a = "loandetails_down__5seb7";
var _b = "#434343";
var _c = "loandetails_icon__9ey-w";
var _d = "loandetails_label__6plvj";
var _e = "79px";
var _f = "110px";
var _10 = "72px";
var _11 = "loandetails_mobiletext__9d97q";
var _12 = "665px";
var _13 = "loandetails_open__tic5m";
var _14 = "loandetails_personalize__fuqar";
var _15 = "loandetails_summary__a5hzn";
var _16 = "teal";
var _17 = "loandetails_text__z3fx9";
var _18 = "2";
var _19 = "#cdd3dc";
var _1a = "loandetails_up__9-ff+";
var _1b = "loandetails_value__e6vsp";
var _1c = "loandetails_wrapper__jzufc";
export { _1 as "arrow", _2 as "arrowWrapper", _3 as "body", _4 as "button", _5 as "controlsMobileWidth", _6 as "controlsStackedWidth", _7 as "darkTeal", _8 as "desktopText", _9 as "detailsText", _a as "down", _b as "headline", _c as "icon", _d as "label", _e as "menuHeight", _f as "menuHeightLarge", _10 as "menuHeightMobile", _11 as "mobileText", _12 as "modalMobileWidth", _13 as "open", _14 as "personalize", _15 as "summary", _16 as "teal", _17 as "text", _18 as "timelineStrokeWidth", _19 as "timelineTrackColor", _1a as "up", _1b as "value", _1c as "wrapper" }
